import { ScoringStatsComponent } from './scoring-stats.component';

export default angular
  .module('sfMobile.components.scoring-stats', [])
  .component('sfScoringStats', ScoringStatsComponent).name;
